import { z } from "zod";
import { TelemetrySpanSchema } from "../pavilion/schemas";
import { type FpProject, FpProjectSchema } from "./codegen";

export const ProjectCreatedEventSchema = z.object({
  type: z.literal("project.created"),

  project: FpProjectSchema,
});
export type ProjectCreatedEvent = z.infer<typeof ProjectCreatedEventSchema>;

export function createProjectCreatedEvent(
  project: FpProject,
): ProjectCreatedEvent {
  return {
    type: "project.created",
    project,
  };
}

export const ProjectUpdatedEventSchema = z.object({
  type: z.literal("project.updated"),

  project: FpProjectSchema,
});
export type ProjectUpdatedEvent = z.infer<typeof ProjectUpdatedEventSchema>;

export function createProjectUpdatedEvent(
  project: FpProject,
): ProjectUpdatedEvent {
  return {
    type: "project.updated",
    project,
  };
}

export const ProjectDeletedEventSchema = z.object({
  type: z.literal("project.deleted"),

  projectId: z.string().nanoid(),
});
export type ProjectDeletedEvent = z.infer<typeof ProjectDeletedEventSchema>;

export function createProjectDeletedEvent(
  projectId: string,
): ProjectDeletedEvent {
  return {
    type: "project.deleted",
    projectId,
  };
}

export const TelemetrySpanCreatedEventSchema = z.object({
  type: z.literal("telemetry.span.created"),
  agentName: z.string(),
  span: TelemetrySpanSchema,
});
export type TelemetrySpanCreatedEvent = z.infer<
  typeof TelemetrySpanCreatedEventSchema
>;

export function createTelemetrySpanCreatedEvent(
  agentName: string,
  span: z.infer<typeof TelemetrySpanSchema>,
): TelemetrySpanCreatedEvent {
  return {
    type: "telemetry.span.created",
    agentName,
    span,
  };
}

export const ProjectArchivedEventSchema = z.object({
  type: z.literal("project.archived"),

  projectId: z.string().nanoid(),
});
export type ProjectArchivedEvent = z.infer<typeof ProjectArchivedEventSchema>;

export function createProjectArchivedEvent(
  projectId: string,
): ProjectArchivedEvent {
  return {
    type: "project.archived",
    projectId,
  };
}

export const EventsSchema = z.discriminatedUnion("type", [
  ProjectCreatedEventSchema,
  ProjectUpdatedEventSchema,
  ProjectDeletedEventSchema,
  TelemetrySpanCreatedEventSchema,
  ProjectArchivedEventSchema,
]);
export type Events = z.infer<typeof EventsSchema>;
